import RequiresAuth from '@website/components/auth/RequiresAuth';
import Conversation from '@website/components/chat/Conversation';
import { CustomerDashboardLayout } from '@website/components/me/userID/CustomerDashboardLayout';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { useRouter } from 'next/router';

export default function CustomerConversation() {
  const { query } = useRouter();

  if (!query.userID) {
    return <LoadingPage />;
  }

  return (
    <RequiresAuth>
      <CustomerDashboardLayout
        activeTab="Messages"
        userID={query.userID as string}
        hideAlerts
      >
        <div
          style={{
            height: '100%',
            maxHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
          }}
        >
          <div
            className="d-flex flex-column"
            style={{ flex: 1, overflowY: 'auto' }}
          >
            <Conversation
              userID={query.userID as string}
              conversationID={query.conversationID as string}
            />
          </div>
        </div>
      </CustomerDashboardLayout>
    </RequiresAuth>
  );
}
